import React, { useEffect, useState } from 'react';
import { Form, Modal, Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import { useForm } from 'antd/es/form/Form';
import { usePrequal } from '../../stores/prequalStore';
import { pushToDataLayer } from '../../utils';
import { withExpVariant } from '../../utils/kamExpVariant';
import PreQualFunnelLayout from '../PreQualFunnelLayout';
import { NavigationRow } from '../components/NavigationRow/NavigationRow';
import SectionHeader from '../components/SectionHeader/SectionHeader';
import RadioButton from '../components/RadioButton/RadioButton';
import { stepFinished } from '../../prequalNav';
import { Prequal, CreditScoreRangeType } from '../../schema';
import FooterCard from '../components/FooterCard/FooterCard';
import { completePrequalFunnelV1 } from '../../utils/prequalHelper';

const formItemLayout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 },
};

const FicoStep = observer(() => {
  const prequalStore = usePrequal();
  const { prequal } = prequalStore;
  const [canContinue, setCanContinue] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form] = useForm();

  const updateValues = async (values: any) => {
    setSubmitting(true);
    prequalStore.setFicoScore(values);
    await completePrequalFunnelV1();
    pushToDataLayer('link_click', {
      action_type: 'click',
      action_label: 'Fico Score - Continue',
    });
    setSubmitting(false);
    stepFinished();
  };

  const checkFicoScoreRange = () => {
    const values = form.getFieldsValue();
    setCanContinue(values.creditScore);
    const creditScoreRangeType = CreditScoreRangeType;
    pushToDataLayer('link_click', {
      action_type: 'click',
      action_label: `${
        creditScoreRangeType[values.creditScore as keyof typeof creditScoreRangeType]
      }`,
    });
  };

  useEffect(() => {
    pushToDataLayer(
      'pageview',
      withExpVariant({
        detailed_page_name: 'fico',
        site_section: 'loan application',
        funnel: 'internal pre-qual',
      })
    );
  }, []);

  useEffect(() => {
    const values = prequal as Prequal;
    if (values.creditScore) {
      setCanContinue(true);
    }
  }, [prequal]);

  const header = {
    title: 'About You',
    subtitle: "What's your credit score?",
    content:
      'Your credit score will help us pre-qualify you. There is no impact to your credit score.',
  };

  return (
    <PreQualFunnelLayout>
      <Modal visible={submitting} footer={null} closable={false}>
        <p>Checking offers for you...</p>
        <Spin size="large" style={{ marginTop: '2rem', display: 'block' }} />
      </Modal>
      <SectionHeader header={header} />
      <Form
        {...formItemLayout}
        form={form}
        initialValues={prequal}
        onFinish={updateValues}
        onValuesChange={checkFicoScoreRange}
      >
        <RadioButton name="creditScore" type={CreditScoreRangeType} useKeyAsValue />
        <NavigationRow canContinue={canContinue} form={form} />
      </Form>

      <FooterCard />
    </PreQualFunnelLayout>
  );
});

export default FicoStep;
